import axios from '../utils/axios';

export default function getJobseekerList(adminId, params) {
    return axios.get(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/listseeker`, { params });
};
